<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">重点运营人群</div>
		</div>
		<!-- 第一部分 -->
		<div class="demo1">
			<div class="demo1_list" v-for="(item,index) in heavylist" :key="index">
				<div class="demo1_title1">{{item.name}}</div>
				<div class="demo1_title2">{{item.crowdDesc}}</div>
				<table cellpadding="0" cellspacing="0">
					<tr>
						<td>
							<p>人群人数</p>
							<p>{{item.crowdAmount}}</p>
						</td>
						<td>
							<p>昨日访客</p>
							<p>{{item.yesterdayVisitor}}</p>
						</td>
						<td>
							<p>昨日成交</p>
							<p>{{item.yesterdayDeal}}</p>
						</td>
					</tr>
				</table>
				<div class="demo1_botton">
					<div><el-button size="small">人群分析</el-button></div>
					<div><el-button size="small">定向运营</el-button></div>
				</div>
			</div>
		</div>
		<!-- 第一部分结束 -->
		<!-- 第二部分开始 -->
		<!-- <div class="title2">用户标签/所属人群</div>
	   <div class="demo2">
		   <div class="demo2_label" v-for="i in 5">
			   付费用户
			   <div @click="claer()">x</div>
		   </div>
		   <div class="demo2_add" @click="dialogVisible = true">
			   + 添加标签/人群
		   </div>
	   </div> -->
		<el-dialog title="添加标签" :visible.sync="dialogVisible" width="30%">
			<el-form label-width="90px">
				<el-form-item label="标签名称" required>
					<el-input style="width:280px;" v-model="labelname" size="medium" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 第二部分结束 -->
		<!-- 第三部分开始 -->
		<div class="title" style="margin-top: 20px;">
			<div class="blue"></div>
			<div style="flex: 1;">人群管理</div>
		</div>
		<div style="margin-bottom: 20px;">
			<router-link to="setpeoples"><el-button size="small" type="primary">新建人群</el-button></router-link>
		</div>
		<div>
			<el-table :header-cell-style="{'background-color':'#F9FCFF','text-align':'center'}"
				:cell-style="{'text-align':'center'}" :data="tableData" border style="width: 100%">
				<el-table-column prop="name" label="人群名称">
				</el-table-column>
				<el-table-column prop="labelDesc" label="人群定义" width="180">
				</el-table-column>
				<el-table-column prop="crowdAmount" label="人群人数">
				</el-table-column>
				<el-table-column prop="updateTime" label="更新时间">
				</el-table-column>
				<el-table-column prop="updateWayStr" label="更新方式">
				</el-table-column>
				<el-table-column prop="totalmoney" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="exportss(scope.row.id)">导出</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 第三部分结束 -->
	</div>
</template>
<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				heavylist: [{
					name: "默认人群",
					crowdDesc: "默认人群简介",
					crowdAmount: 0,
					yesterdayVisitor: 0,
					yesterdayDeal: 0
				}],
				radio: "",
				dialogVisible: false,
				labelname: "",
				//第三部分表格
				tableData: [{
					totalmoney: "无",
					totalnum: "无",
					agreemoney: "无",
					jifen: "无",
					duihuannum: "无",
					youhui: "无",
					cishu: "无"
				}]
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			//导出
			exportss(id) {
				let urls = this.url + "dUserCrowd/exporDEvaluate?crowdId=" + id
				window.location.assign(urls)
			},
			//获取用户群
			getlist() {
				this.$http.get("dUserCrowd/list").then(function(res) {
					if (res.body.code == 200) {
						this.heavylist = res.body.data.keyNoteCrowd
						this.tableData = res.body.data.crowdList
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			claer() {
				this.$confirm('是否要删除该标签?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	};
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第一部分
	.demo1 {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		// 第一部分列表
		.demo1_list {
			margin-right: 40px;
			width: 313px;
			height: 313px;
			background-color: #F2F2F2;
			box-sizing: border-box;

			&:nth-child(n+4) {
				margin-top: 25px;
			}

			.demo1_title1 {
				margin: 20px;
				margin-bottom: 0;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #3A3A3A;
			}

			.demo1_title2 {
				margin-left: 20px;
				margin-top: 10px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #848484;
			}

			table {
				margin-top: 20px;
				text-align: center;
				width: 313px;
				background-color: white;

				tr {
					width: 100%;
					height: 128px;
					display: flex;

					td {
						flex: 1;
						border: 1px solid #D3D3D3;

						p {
							&:nth-child(2) {
								margin-top: 40px;
							}
						}
					}
				}
			}

			.demo1_botton {
				display: flex;
				margin-top: 25px;

				>div {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;
					flex: 1;
				}
			}
		}

		//第二部分
		.demo1_add {
			cursor: pointer;
			width: 313px;
			height: 313px;
			background-color: #F2F2F2;
			box-sizing: border-box;
			position: relative;

			img {
				width: 121px;
				height: 121px;
				position: absolute;
				left: 50%;
				top: 50%;
				margin-left: -60.5px;
				margin-top: -60.5px;
			}
		}

	}

	// 第二部分
	.demo2 {
		box-sizing: border-box;
		width: 100%;
		padding: 20px;
		padding-top: 10px;
		min-height: 150px;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #D3D3D3;

		.demo2_label {
			cursor: pointer;
			height: 23px;
			margin-top: 10px;
			padding: 10px;
			background: #FFFFFF;
			border: 1px solid #D3D3D3;
			position: relative;

			& {
				margin-right: 20px;
			}

			&:hover div {
				display: block;
			}

			div {
				display: none;
				text-align: center;
				line-height: 12px;
				font-size: 12px;
				color: #FFFFFF;
				border-radius: 50%;
				position: absolute;
				right: -5px;
				top: -5px;
				height: 15px;
				width: 15px;
				background-color: #000000;
			}
		}

		.demo2_add {
			height: 23px;
			margin-top: 10px;
			cursor: pointer;
			padding: 10px;
			background: #FFFFFF;
			border: 1px dashed #D3D3D3;
		}
	}
</style>